import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const heroScroll = () => {
  const logo = document.querySelector('.hero .logo-lg');
  const contentBelow = document.querySelector('.below-hero');

  gsap.to(logo, {
    autoAlpha: 0,
    scale: 0,
    scrollTrigger: {
      trigger: contentBelow,
      start: 'top bottom',
      end: '+=2000px',
      scrub: 1
    }
  });
};

export default heroScroll;
